import "./NavigationBar.style.css";

// React Bootstrap Icons
import { List, XLg } from "react-bootstrap-icons";

const NavigationBar = () => {
    return (
        <header className="navbar">
            <div className="navbar-brand">
                <h1>PT Irwan <span>Sukses Abadi</span></h1>
            </div>

            <input type="checkbox" id="checkbox" />
            <label htmlFor="checkbox" className="navbar-toggle">
                <List color="white" id="menu-icon" />
                <XLg color="white" id="close-icon" />
            </label>

            <nav className="navbar-menu">
                <a href="#home" className="navbar-link">Home</a>
                <a href="#about-us" className="navbar-link">About Us</a>
                <a href="#service" className="navbar-link">Service</a>
                <a href="#contact" className="navbar-link">Contact</a>
            </nav>
        </header>
    );
};

export default NavigationBar;